import SendEmailProvider from '../providers/send-email-provider';

class SendEmailRepository {

    constructor() {
        this.sendEmailProvider = new SendEmailProvider();
    }

    enviarCorreo = async (datosEnvioCorreo) => {
        return this.sendEmailProvider.enviarCorreo(datosEnvioCorreo);
    }

}

export default SendEmailRepository;